export default __webpack_public_path__ + "static/media/insta.182dc675.svg";